
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'RtlNowBackground'
})
export default class RtlNowBackground extends Vue {}
